const AvsAn = require('vendor/a_or_an')
const log = require('log').create('text') // eslint-disable-line
require('lib/dateformat')

function getAOrAn(followed_by) {
    // just a wrapper
    return AvsAn.query(followed_by)
}

function capitalize(s) {
    return s.charAt(0).toUpperCase() + s.slice(1)
}

function capitalizeWords(s) {
    // http://stackoverflow.com/questions/2332811/capitalize-words-in-string
    return s.replace(/(?:^|\s)\S/g, a => a.toUpperCase())
}

// convert a string timestamp into a human-readable date string
function formatDate(timestamp, format = 'mmmm d, yyyy') {
    let ts = timestamp
    log('timestamp', timestamp)

    // reformat mongo timestamps to use dddd/dd/dd dd:dd:dd
    const mongo_timestamp_regex = /\d\d\d\d-\d\d-\d\d[T| ]\d\d:\d\d:\d\d/
    if (mongo_timestamp_regex.test(ts)) {
            // date string is in expected format
        ts = ts.replace(/-/g, '/').replace(/T/g, ' ')
    }

    const dateobj = new Date(Date.parse(ts))

    return dateobj.format(format)
}

// returns the correct possessive form of the display name or the provided name
function possessive(input_name, quote = '’') {
    let name = input_name

    if (! name) return ''

    name = name.trim()
    if (! name) return ''

    if (name.match(/s$/)) {
        name = `${name}${quote}`
    } else {
        name = `${name}${quote}s`
    }

    return name
}

module.exports = {
    getAOrAn,
    capitalize,
    capitalizeWords,
    formatDate,
    possessive,
}
